const generateHeader = (dataCopy, idx, key) => {
    const idCurso   = dataCopy[idx]["IdCurso"]
    const idHorario = dataCopy[idx]["Horarios"][0]["IdHorario"]
    const idPlan    = dataCopy[idx]["Horarios"][0]["IdPlan"]
    const idPeriodo = dataCopy[idx]["Horarios"][0]["IdPeriodo"]

    return {
      "IdCurso"   : idCurso,
      "IdHorario" : idHorario,
      "IdPlan"    : idPlan,
      "IdPeriodo" : idPeriodo,
      "Key"       : key,
    }
  }

  
  export {
    generateHeader,
  }